export default __webpack_public_path__ + "static/media/system_update.544b8e8e.csv";